import { EventHandlingStrategy } from "./abstract.strategy";
import {
  ClientEventHandler,
  ClientsService,
  IMessageFromServerPong,
  IMessagesFromServer,
  IMessagesToClient,
  ISubscriptionPayloadParams,
  SocketService,
} from "services";
import {
  CLIENT_CONNECTED,
  CLIENT_DISCONNECTED,
  CLIENT_PING,
  SERVER_CONNECT,
  SERVER_CONNECTED,
  SERVER_PONG,
  SERVER_UNSUBSCRIBE,
} from "constants/events";
import { getRandomRequestId } from "utils/utils";

export class SystemStrategy extends EventHandlingStrategy {
  private rid: string = "";

  constructor(clientsService: ClientsService, socketService: SocketService) {
    super(clientsService, socketService);
  }

  static getEvents(): [string | null, string | null][] {
    return [
      [CLIENT_CONNECTED, SERVER_CONNECTED],
      [CLIENT_DISCONNECTED, null],
      [CLIENT_PING, SERVER_PONG],
      [null, SERVER_UNSUBSCRIBE],
    ];
  }

  public sendConnectSystemMessage(language: string) {
    this.rid = getRandomRequestId();
    this.socketService.startSubscription(this.rid, SERVER_CONNECT, {
      language: language,
    });
  }

  on<T extends IMessagesToClient>(
    event: T,
    handler: ClientEventHandler<T>,
    ...payload: ISubscriptionPayloadParams<T>
  ): string {
    this.clientsService.subscribe(event, handler);
    return event;
  }

  off<T extends IMessagesToClient>(event: T, handler: ClientEventHandler<T>): string | undefined {
    this.clientsService.unsubscribe(event, handler);
    return event;
  }

  handleServerMessage(message: IMessagesFromServer | IMessageFromServerPong) {
    switch (message.event) {
      case SERVER_PONG:
        this.clientsService.sendClientMessage(CLIENT_PING, message.data);
        break;
      case SERVER_UNSUBSCRIBE:
        // do nothing, unsubscribed
        break;
      case SERVER_CONNECTED:
        if (message.rid !== this.rid) {
          return;
        }

        if (message.event === SERVER_CONNECTED) {
          this.clientsService.sendClientMessage(CLIENT_CONNECTED, message.data);
        }
        break;
    }
  }
}
